import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-de",
  "use": "icon-cl-de-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-cl-de\"><mask id=\"icon-cl-de_a\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"><circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#D9D9D9\" /></mask><g mask=\"url(#icon-cl-de_a)\"><path d=\"M0 16.682h24v8H0v-8Z\" fill=\"#FFCE00\" /><path d=\"M0-.318h24v8H0v-8Z\" fill=\"#000\" /><path d=\"M0 7.682h24v9H0v-9Z\" fill=\"#D00\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol